
import Swipeout from './src/';
export default Swipeout;


// WEBPACK FOOTER //
// ./index.js